(function () {
  function getSubsVariant() {
    var v = (sessionStorage.getItem('subs_variant') || '').toLowerCase();
    return v || 'rc'; // default = Recharge
  }
  
  var subs = getSubsVariant();
  var hide = subs === 'kb';
  if (!hide) return;

  document.documentElement.setAttribute('data-hide-recharge', 'true');

  var BLOCK = [
    'recharge',
    'rechargecdn.com',
    'rechargepayments.com',
    'static.rechargecdn.com'
  ];

  function shouldBlockUrl(url) {
    if (!url) return false;
    url = String(url).toLowerCase();
    return BLOCK.some(function (s) { return url.indexOf(s) !== -1; });
  }

  function killRechargeDom() {
    document.querySelectorAll('script[src], link[href], iframe[src]').forEach(function (el) {
      var url = el.src || el.href;
      if (shouldBlockUrl(url)) el.remove();
    });

    document.querySelectorAll(
      '.rc-container-wrapper, .rc_container_wrapper, .rc-wrapper, .rc_wrapper, .rc-widget, .rc_widget,' +
      'recharge-subscription-widget, .shopify-app-block.recharge-subscription-widget'
    ).forEach(function (el) { el.remove(); });
  }

  // Block future script injection by neutering Recharge widget script nodes
  var origAppendChild = Element.prototype.appendChild;
  Element.prototype.appendChild = function (node) {
    try {
      if (node && node.tagName === 'SCRIPT' && shouldBlockUrl(node.src)) {
        node.type = 'javascript/blocked';
        node.remove();
        return node;
      }
    } catch (e) {}
    return origAppendChild.call(this, node);
  };

  // Block fetch/XHR to Recharge endpoints
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url);
      if (shouldBlockUrl(url)) return new Promise(function () {});
      return origFetch.apply(this, arguments);
    };
  }

  var OrigXHR = window.XMLHttpRequest;
  if (OrigXHR) {
    var origOpen = OrigXHR.prototype.open;
    OrigXHR.prototype.open = function (method, url) {
      if (shouldBlockUrl(url)) {
        try { this.abort(); } catch (e) {}
        return;
      }
      return origOpen.apply(this, arguments);
    };
  }

  killRechargeDom();
  document.addEventListener('DOMContentLoaded', killRechargeDom, { once: true });
  new MutationObserver(killRechargeDom).observe(document.documentElement, { childList: true, subtree: true });
})();
